module.exports = __webpack_public_path__ + "img/selected-farewell-of-snezhnaya.d4103a62.webp";